import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  increase: {
    description: 'Accessible label for the button that increases a number input value',
    defaultMessage: 'Increase',
    id: 'AVlTLa',
  },
  decrease: {
    description: 'Accessible label for the button that decreases a number input value',
    defaultMessage: 'Decrease',
    id: 'cxnxjX',
  },
});
